import { createSlot } from "lib/@components/slot/create-slot"

export const CustomScheduleActions = createSlot("CustomScheduleActions")
